import { toast } from 'sonner';
import { problemText, toApiError, type Api, type DocumentResponse } from '@/shared/api';

/** Fetcht das Document via Auth-Header, baut ObjectURL, triggert Browser-Download. */
export function downloadGuestDocument(api: Api, guestProfileId: string, doc: DocumentResponse) {
  api.guests
    .downloadDocument(guestProfileId, doc.id)
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `${doc.kind}-${doc.id.slice(0, 8)}`;
      a.click();
      // Sofort freigegeben bricht der Download in Firefox und Safari still ab.
      window.setTimeout(() => URL.revokeObjectURL(blobUrl), 10_000);
    })
    .catch(async (err: unknown) => {
      const e = await toApiError(err);
      toast.error(problemText(e, 'Das Dokument konnte nicht geladen werden.'));
    });
}
